import React, { useState } from 'react'
import { sendLoginPayload } from 'account-portal-library/lib/emailSignIn';
import AppVars from './../../AppVars';
import Logger from '../../Logger.js';
import { DigitInput } from '../Views/TO/Login/DigitInput';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';

import { maskPhoneNumber } from './MfaSelectPage';
import LoadingGif from '../../static/images/loading.gif';
import Logo from '../../static/images/TO/toyota-logo.svg';

let appVars = AppVars.getInstance();
let logger = Logger.getInstance();

const ACCOUNT_LOCKED_URL = "/accountlocked"

const MfaTextPage = ({ style = 'TO', savePayload, payload, saveStep, phoneNumber = "1234567890" }) => {
    const [smsData, setSmsData] = useState("");
    const [validNext, setValidNext] = useState(false);
    const [codeErr, setCodeErr] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resendConfirmed, setResendConfirmed] = useState(false);

    const onChange = (value) => {
        if (value.trim().length === 6) {
            setValidNext(true)
        } else {
            setValidNext(false)
        }
        setSmsData(value.trim())
    };

    const requestCodeApi = async (action) => {
        const url = appVars.getBaseUrl() + '/' + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
        const headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
        }
        const params = {
            'authIndexType': 'service',
            'authIndexValue': appVars.getEmailSignInTree()
        }
        let textPayload = payload.response
        if (payload.status < 299) {
            if (action === 1) {
                textPayload.callbacks[1].input[0].value = "";
            } else {
                textPayload.callbacks[1].input[0].value = smsData;
            }
            textPayload.callbacks[2].input[0].value = action;
        }
        const choiceResponse = await sendLoginPayload(textPayload, url, headers, params)
        handleLoginResponse(choiceResponse)
    }

    const handleLoginResponse = (loginResponse) => {
        if (validateForm(loginResponse.status)) {
            handleSuccess(loginResponse);
        } else {
            handleFailure(loginResponse);
        }
    }

    const validateForm = (status) => {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    const handleSuccess = async (loginResponse) => {
        logger.log("test", loginResponse)
        logger.log("test", loginResponse.response.callbacks)
        if (loginResponse.response.callbacks == null) {
            console.log("failure or session expired")
            window.location.replace(appVars.getUnknownErrorURL(style));
        } else {
            setLoading(false)
            if (loginResponse.response.callbacks[0].type == 'HiddenValueCallback') {
                setCodeErr(true);
                setResendConfirmed(false);
            } else if (loginResponse.response.callbacks[0].type == 'ChoiceCallback') {
                savePayload(loginResponse)
                saveStep("TRUST")
            } else if (loginResponse.response.callbacks[0].type == 'TextOutputCallback') {
                setResendConfirmed(true);
            } else {
                window.location.replace(appVars.getUnknownErrorURL(style));
            }
        }
    }

    const handleFailure = (loginResponse) => {
        var failureUrl = loginResponse.failureUrl
        //If invalid credentials
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            setLoading(false)
            window.location.replace(ACCOUNT_LOCKED_URL);
        }
        else {
            if (loginResponse.message == 'Session has timed out') {
                window.location.href = "/";
            } else {
                console.log(loginResponse.message)
                window.location.replace(appVars.getUnknownErrorURL(style));
            }
        }
    }

    const onSubmit = () => {
        if (smsData.length === 6) {
            setLoading(true)
            requestCodeApi(0)
        }
    }

    const onResend = () => {
        setLoading(true)
        requestCodeApi(1)
    }

    return <div className="login-wrapper" >
        <div className="relative login-box">
            <img src={Logo} className="login-logo__TO absolute" alt="Toyota Owners"></img>
            <div className="title__TO left">OTP verification</div>
            <div className="sign-in-mfa-grid">
                <div className="sign-in-subtitle-left sign-in-subtitle">Please enter the code we sent to your phone number {maskPhoneNumber(phoneNumber)}.  </div>
            </div>
            <form className='text-form'>
                <fieldset>
                    <legend>Enter 6 Digit Code</legend>
                    <DigitInput value={smsData} valueLength={6} onChange={onChange} />
                </fieldset>
                {codeErr && <div
                    data-testid="logonUsernameError"
                    className={`digit-alert ${codeErr ? "block" : "none"}`}
                    role="alert"
                    aria-hidden={`${codeErr ? "false" : "true"}`}
                >
                    Request a new code or try again.
                </div>}
                {resendConfirmed && <div
                    data-testid="logonUsernameError"
                    className={`digit-resent ${resendConfirmed ? "block" : "none"}`}
                    role="alert"
                    aria-hidden={`${resendConfirmed ? "false" : "true"}`}
                >
                    New code has send successfully.
                </div>}
            </form >
            <div className='mfa-button-group'>
                <Button bsPrefix="login-button-outline__TO button-duration" type="submit" onClick={onResend}>Resend code</Button>
                <Button bsPrefix={validNext ? "login-button__TO" : "login-button-disabled__TO"} type="submit" onClick={onSubmit} >Next Step</Button>
            </div>
        </div>
        <Image data-testid="loadingGIF" className={`working ${loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
    </div>
}

export default MfaTextPage;